
































import Vue from 'vue'
import Component from 'vue-class-component'
import Modal from '../Modal.vue'
import { ResidentModule } from '@/store/modules/resident.module'
import { getModule } from 'vuex-module-decorators'
import { EUserPermissions } from '@zunta/configurations'
import { User } from '@/classes/User'
import Api from '@/api'
import ModalV2 from '@/components/modals/ModalV2.vue'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
import { required } from 'vuelidate/lib/validators'
import TextareaV2 from '@/components/inputsV2/TextareaV2.vue'

@Component({
  components: {
    TextareaV2,
    InputValidator,
    ModalV2,
    Modal
  },
  props: {
    historyItem: {
      required: true,
      type: Object
    }
  }
})
export default class EditHistoryCommentModal extends Vue {
  user: User = Api.getUser() as User
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  isLoading: boolean = false
  note: string = ''

  validations (): any {
    return {
      note: {
        required
      }
    }
  }

  mounted () {
    this.note = this.$props.historyItem.note
  }

  async addNote () {
    if (!this.user.hasPermissionFor(EUserPermissions.ADD_HISTORY_NOTE)) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Permission Denied',
        header: `Add History Note`,
        icon: 'warning'
      })
      return
    }

    this.$v.$touch()
    if (this.$v.$anyError) {
      return
    }

    this.isLoading = true
    const result = await this.residentModuleInstance.addResidentHistoryNote({
      residentId: this.$props.historyItem.residentId,
      data: {
        user: this.user.data.id,
        note: this.note
      }
    })
    this.isLoading = false

    if (result === 'OK') {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-success-color)',
        message: 'Note Added',
        header: `Add History Note`,
        icon: 'check'
      })
      this.$emit('success')
      return
    }

    this.$eventBus.$emit('notify', {
      color: 'var(--status-error-color)',
      message: 'Something went wrong',
      header: `Add History Note`,
      icon: 'warning'
    })
  }

  async editHistory () {
    if (!this.$props.historyItem || !this.$props.historyItem.id) {
      return
    }

    this.$v.$touch()
    if (this.$v.$anyError) {
      return
    }

    this.isLoading = true
    await this.residentModuleInstance.updateCollectionHistory({
      historyId: this.$props.historyItem.id,
      payload: {
        note: this.note
      }
    })
    this.isLoading = false
    this.$emit('success')
  }
}
